import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";

export const Preview = ({ value, className = "" }) => {
  return (
    <div className={`preview-container ${className}`}>
      <style>
        {`
          .preview-container .ql-editor {
            padding: 0 !important;
            font-size: inherit;
            line-height: inherit;
          }
          .preview-container .ql-container {
            font-size: inherit;
            font-family: inherit;
          }
        `}
      </style>
      <ReactQuill theme="bubble" value={value} readOnly />
    </div>
  );
};

export default Preview;
